import {
  ExternalBankAccount,
  ExternalBankAccountStatus,
  ExternalBankAccountVerificationMethod
} from "@wingspanhq/wingspan-api-sdk";

export const selectorExternalBankAccountVerificationPending = (
  externalBankAccount: ExternalBankAccount
) =>
  externalBankAccount.status === ExternalBankAccountStatus.PENDING &&
  externalBankAccount.verificationMethod ===
    ExternalBankAccountVerificationMethod.MICRO_DEPOSIT;
